import React, { useCallback } from 'react';
import { TableCollection, Empty } from 'src/components';
import { Box, Panel, Tag, Button, Text } from 'src/components/matchbox';
import { formatLongDateTime } from '@sparkpost/report-builder/helpers/date';
import { getEvaluatorOptions } from '../helpers/alertForm';
import { roundToPlaces } from '@sparkpost/report-builder/helpers/units';
import _ from 'lodash';
import { ChevronRight } from '@sparkpost/matchbox-icons';
import { PageLink } from 'src/components/links';
import { TranslatableText } from 'src/components/text';

const filterBoxConfig = {
  show: true,
  itemToStringKeys: ['name', 'assignment'],
  exampleModifiers: ['name']
};

const AlertIncidents = ({ incidents = [], alert }) => {
  const { metric, threshold_evaluator = {} } = alert;
  const { source } = threshold_evaluator;
  const { suffix } = getEvaluatorOptions(metric, source);

  const columns = [
    { label: 'Date Triggered', sortKey: 'first_fired', key: 'alert_incident_header_triggered' },
    { label: 'Date Resolved', key: 'alert_incident_header_status' },
    {
      label: 'Bounce Rate',
      sortKey: 'triggered_value',
      key: 'alert_incident_header_label',
      align: 'right'
    },
    { label: 'Subaccount', key: 'subaccount' },
    { label: '', key: 'analytics' }
  ];

  const getRowData = useCallback(
    ({ first_fired, last_fired, status, triggered_value, assignment }) => {
      return [
        <Box>{formatLongDateTime(first_fired)}</Box>,
        <Box>
          {status === 'Open' ? (
            <Tag color="yellow">Active</Tag>
          ) : last_fired ? (
            formatLongDateTime(last_fired)
          ) : (
            <Text as="i">Not yet resolved</Text>
          )}
        </Box>,
        <Box textAlign="right">
          <TranslatableText>{roundToPlaces(triggered_value, 1)}</TranslatableText>
          <TranslatableText>{suffix}</TranslatableText>
        </Box>,
        <Box>
          <Tag>{assignment}</Tag>
        </Box>,

        <Box textAlign="right">
          <PageLink
            as={Button}
            variant="minimal"
            to={{
              pathname: '/signals/analytics'
            }}
          >
            View Analytics
            <Button.Icon as={ChevronRight} />
          </PageLink>
        </Box>
      ];
    },
    [suffix]
  );

  return (
    <>
      {incidents.length <= 0 ? (
        <Panel.LEGACY>
          <Empty message="No incidents" />
        </Panel.LEGACY>
      ) : (
        <TableCollection
          rows={incidents}
          columns={columns}
          getRowData={getRowData}
          pagination
          defaultSortColumn="first_fired"
          defaultSortDirection="desc"
          filterBox={filterBoxConfig}
          placeholder="e.g. Sparky’s Cookie Co. or monthly-newsletter"
        />
      )}
    </>
  );
};

export default AlertIncidents;
